export const HttpStatus = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403
}



// WEBPACK FOOTER //
// ./src/utils/httpstatus.js